module.exports = __webpack_public_path__ + "static/img/tuceng5.b951695.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tuceng5.png
// module id = YbWY
// module chunks = 2